import { gql } from "@apollo/client";

export const GET_JUSTIFICACIONES_MOTIVOS = gql`
  query GetJusticacionesMotivos {
    justicacionesMotivos {
      idMotivoJustificacion
      descripcionCorta
      descripcionLarga
      estado
      area
    }
  }
`;